'use client'

import { useCallback, useEffect, useState } from 'react'

const DEFAULT_RATE_LIMIT_MS = 30_000

export const formatRateLimitMessage = (seconds: number): string => {
  const safeSeconds = Math.max(1, Math.ceil(seconds))
  return `Demasiados intentos. Espera ${safeSeconds}s y vuelve a intentar.`
}

export const useRateLimitCooldown = (defaultMs: number = DEFAULT_RATE_LIMIT_MS) => {
  const [cooldownUntil, setCooldownUntil] = useState<number | null>(null)
  const [cooldownSeconds, setCooldownSeconds] = useState(0)

  const startCooldown = useCallback(
    (retryAfterMs?: number | null) => {
      const duration =
        typeof retryAfterMs === 'number' && Number.isFinite(retryAfterMs) && retryAfterMs > 0
          ? retryAfterMs
          : defaultMs
      setCooldownUntil(Date.now() + duration)
    },
    [defaultMs]
  )

  const clearCooldown = useCallback(() => {
    setCooldownUntil(null)
    setCooldownSeconds(0)
  }, [])

  useEffect(() => {
    if (!cooldownUntil) return

    const tick = () => {
      const remaining = Math.max(0, Math.ceil((cooldownUntil - Date.now()) / 1000))
      setCooldownSeconds(remaining)
      if (remaining <= 0) {
        setCooldownSeconds(0)
        setCooldownUntil(null)
      }
    }

    tick()
    const timer = window.setInterval(tick, 1000)
    return () => window.clearInterval(timer)
  }, [cooldownUntil])

  return {
    cooldownSeconds,
    isCoolingDown: cooldownSeconds > 0,
    startCooldown,
    clearCooldown,
  }
}
